import { render, staticRenderFns } from "./ActionCombo.vue?vue&type=template&id=00ff265a"
import script from "./ActionCombo.vue?vue&type=script&lang=js"
export * from "./ActionCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports